import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import AxiosUtil from "../../utils/AxiosUtil";
import {Button, Drawer, message, Modal} from "antd";
import {ExpandOutlined, LinkOutlined, QuestionCircleOutlined,CodeOutlined} from "@ant-design/icons";
import MyRawData from "../../components/MyRawData";
import {ActionType, ProTable} from "@ant-design/pro-components";
import FetchUtil from "../../utils/FetchUtil";
import DataUtil from "../../utils/DataUtil";

const {confirm} = Modal

const AiGameLogs = (props: any, ref:any) => {

    // const formRef = useRef();
    const actionRef = useRef<ActionType>();

    // const [total, setTotal] = useState(0);
    // const [mainData, setMainData] = useState<any[]>();
    const [mainQuery, setMainQuery] = useState<any>();

    const [openForm, setOpenForm] = useState(false);
    const [openForm2, setOpenForm2] = useState(false);
    const [form2Text, setForm2Text] = useState<string>("");

    useEffect(() => {
        actionRef.current?.reload();
    }, [mainQuery]);

    useImperativeHandle(ref, () => {
        return {
            openEditor: (type: string, relId: number) => {
                setMainQuery({type: type, relId: relId});
                setOpenForm(true);
            }
        }
    });

    const columns: any[] = [
        {
            title: 'ID',
            dataIndex: 'id',
        },
        {
            title: 'Keyword',
            dataIndex: 'keyName',
        },
        {
            title: 'Value',
            dataIndex: 'keyValue',
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
            align: 'center' as 'center',
            valueType: "dateTime"
            // render: (v: number) => {
            //     return v === null ? '' : moment(v).format('yyyy-MM-DD HH:mm:ss')
            // },
        },

    ];

    const onOpenForm2 = (id: number) => {
        AxiosUtil.AxiosRequest("/mallApi/seo/logDetail", {id: id},
            (suc, data) => {
                if (suc) {
                    setForm2Text(data.remark);
                    setOpenForm2(true);
                }
            })
    }
    const closeForm2 = () => {
        setOpenForm2(false);
    }

    return (
        <Drawer placement="right"
                width={720}
                open={openForm}
                onClose={() => {
                    setOpenForm(false);
                    setMainQuery(undefined);
                }}
                title={"日志"}
                forceRender={true}>

            <ProTable key='contract'
                      actionRef={actionRef}
                      rowKey='id'
                      columns={columns}
                      size="small"
                      search={false}
                      pagination={{showQuickJumper: true,showSizeChanger: true}}
                      request={async (
                          params // , sort, filter,
                      ) => {
                          if (mainQuery) {
                              const query: any = {
                                  query: {...mainQuery},
                                  page:{ pageSize: params.pageSize, pageNo: params.current}
                              }
                              const res = await FetchUtil.awaitFetch('/mallApi/aiGame/logList', query);
                              // setMainData(res.data.list);
                              return {
                                  success: true,
                                  data: res.data.list,
                                  total: res.data.total,
                              }
                          }else {
                              return {success: true, data: []}
                          }
                      }}
            />

            <Drawer placement="right"
                    width={880}
                    open={openForm2}
                    onClose={closeForm2}
                    title={<span><ExpandOutlined/> 元数据</span>}>
                <MyRawData rawData={form2Text} label="Post Raw"/>
            </Drawer>
        </Drawer>
    );
}
export default forwardRef(AiGameLogs)
